import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    showBank, stateList, loantypList,
    securitytypList, statusList, activitytypList, createAccount,
    getAccountDataByID, uploadFile, showImage,
    getMortgagePropertyByAccount
} from '../http/api';
import SideNave from '../common/sidenav';
import TopNav from '../common/topnav';
import '../common/style.css';
import Select from "react-select";
import { useAuth } from "../http/authcontex";
import { FaRegTrashAlt, FaPlus, FaRegSave } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TiDeleteOutline } from 'react-icons/ti';
import { IoMdDownload } from 'react-icons/io';
import Loading from "../loading/loading";

export default function AddSarfaesi() {

    //const { state } = useLocation();
    //const user = state?.user;


    const authContext = useAuth();
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    const { userEmail } = useAuth();


    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [formData, setFormData] = useState({
        id: 0,
        accountName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
        phoneNumber: "",
        email: "",
        dateOfAllotment: "",
        npaDate: "",
        dateOf132: "",
        dateOf134: "",
        amountDemanded132: "",
        registeredMortgagedSrNo: "",
        status: "",
        remark: "",

        bank: {
            id: 0,
            bankName: '',
            logo: null,
            submittedBy: '',
            active: true,
            branch: {
                branchName: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                pinCode: '',
                branchManagerName: '',
                phoneNumber: '',
                mobile: '',
                email: '',

                contactPerson: {
                    designation: '',
                    mobile: '',
                    email: '',
                    name: ''
                }
            },

            regionalOffice: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                pinCode: '',
                phoneNumber: '',
                email: ''
            },
            zonalOffice: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                pinCode: '',
                phoneNumber: '',
                email: ''
            }
        },
        loanType: [
            {
                id: 0,
                loanType: "",
                sanctionDate: "",
                sanctionAmount: 0,
                outstandingAmount: 0,
                outstandingAsOf: "",
                rateOfInterest: 0,
            }
        ],
        applicants: [
            {
                id: 0,
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                pinCode: "",
                mobile: "",
                email: ""
            }
        ],
        guarantors: [
            {
                id: 0,
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                pinCode: "",
                mobile: "",
                email: ""
            }
        ],
        securityDetails: [
            {
                id: null,
                securityType: "",
                securityDetails: "",
                towardsEast: "",
                towardsWest: "",
                towardsNorth: "",
                towardsSouth: ""
            }
        ],
        activityDetails: [
            {
                id: 0,
                activityType: "",
                dateOfActivity: "",
                timeSpent: 0,
                approxExpenses: 0,
                photoEvidence: null,
                fileEvidencePath: "",
                activityDetails: "",
                officelocation: "",
                securityDetails: [
                    {
                        id: null,
                        securityDetails: ""
                    }
                ]

            }
        ],

        buyerDetails: [
            {
                id: 0,
                buyertype: "",
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                pinCode: "",
                mobile: "",
                email: "",
                pan: "",
                aadhar: ""

            }]

    });

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(1);
    const [errors, setErrors] = useState({});

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    const handleLoanDetailChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            loanType: prev.loanType.map((loan, i) =>
                i === index ? { ...loan, [name.split(".")[1]]: value } : loan
            ),
        }));
    };


    const addLoanDetail = () => {
        setFormData(prev => ({
            ...prev,
            loanType: [
                ...prev.loanType,
                {
                    id: 0,
                    loanType: '',
                    sanctionDate: '',
                    sanctionAmount: 0,
                    outstandingAmount: 0,
                    outstandingAsOf: '',
                    rateOfInterest: 0,
                }
            ]
        }));
    };


    const getAccountDteatlsByID = useCallback(() => {
        setLoading(true);
        getAccountDataByID(formData.id)
            .then((response) => {
                if (response.status === 201 || response.status === 200) {
                    setLoading(false);
                    setFormData(response.data);

                }
            }).catch((error) => {
                setLoading(false); // Reset loading state
                if (error.response && error.response.status === 401) {
                    console.error("Unauthorized access, redirecting to login...");
                    authContext.logout();
                    navigate("");
                } else {
                    //console.error("Error during file upload:", error);
                    //alert("File upload failed! Please try again.");
                }
            });
    },
        [formData.id, authContext, navigate]
    );

      // Populate form data when editing
      useEffect(() => {
        // console.log('Received data 1 :', location.state.bank);
        if (location.state) {
            //console.log('Locations Data >> ' + location.state.bankDetals);
            console.log('Received data 2 :', location.state.accountDetails.id);
            //formData.id = location.state.accountDetails.id;

            setFormData((prevFormData) => ({
                ...prevFormData,
                id: location.state.accountDetails.id,
            }));

            getAccountDteatlsByID();
        }
    }, [location.state, getAccountDteatlsByID]);

    const removeLoanDetail = (index) => {
        setFormData((prev) => ({
            ...prev,
            loanType: prev.loanType.filter((_, i) => i !== index),
        }));
    };

    const handleLoanTypChange = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedLoanType = [...prevFormData.loanType];
            updatedLoanType[index] = {
                ...updatedLoanType[index],
                loanType: selectedOption ? selectedOption.value : '', // Set the value from the dropdown
            };
            return { ...prevFormData, loanType: updatedLoanType };
        });
    };

    const addActivityDetail = () => {
        setFormData(prev => ({
            ...prev,
            activityDetails: [
                ...prev.activityDetails,
                {
                    id: 0,
                    activityType: '',
                    dateOfActivity: '',
                    timeSpent: 0,
                    approxExpenses: 0,
                    photoEvidence: null,
                    fileEvidencePath: '',
                    activityDetails: '',
                    officelocation: '',
                    securityDetails: [
                        {
                            id: null,
                            securityDetails: ""
                        }
                    ]
                }
            ]
        }));
    };

    const removeActivityDetail = (index) => {
        setFormData(prev => {
            const updatedActivityDetails = [...prev.activityDetails];
            updatedActivityDetails.splice(index, 1);
            return { ...prev, activityDetails: updatedActivityDetails };
        });
    };


    const handleTabChange = (tab) => {
        if (validateTab1()) {
            setActiveTab(tab);
        }
    };


    const handleSave = (tab) => {
        if (validateTab1()) {
            // Proceed with form submission
            formData.submittedBy = userEmail;

            console.log("formData " + formData);
            console.log("formData", JSON.stringify(formData, null, 2));

            createAccount(formData).then(response => {
                if (response.status >= 200 || response.status <= 201) {
                    console.log(response.status);
                    //setFormData(response.data);
                    formData.id = response.data.id;
                    fetchMortgageProperties();
                    toast.success("Data saved successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        style: { border: "3px solid green", padding: "10px" },
                    });
                } else {
                    toast.error("Error saving data. Please try again.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        style: { border: "3px solid red", padding: "10px" },
                    });
                }
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    const errorMessage = typeof error.response?.data?.message === 'string'
                        ? error.response.data.message
                        : JSON.stringify(error.response?.data?.message) || "Error saving data. Please try again.";

                    console.log("errorMessage: ", errorMessage);
                    toast.error(errorMessage, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        style: { border: "3px solid red", padding: "10px" },
                    });
                }

            });
        }
    };

    const renderError = (field) => {
        return errors[field] ? <small className="text-danger">{errors[field]}</small> : null;
    };


    //Getting State and City Details
    const viewStateDetails = useCallback(() => {
        setLoading(true);
        stateList()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success ", response.data);
                    const states = response.data;
                    // Transform states and cities for dropdown
                    const stateDropdownOptions = states.map(state => ({
                        value: state.name,
                        label: state.name,
                        cities: state.cities.map(city => ({
                            value: city.name,
                            label: city.name,
                        })),
                    }));

                    setStateOptions(stateDropdownOptions);
                    setStateOptionsApl(stateDropdownOptions);
                    setStateOptionsGur(stateDropdownOptions);
                    setStateOptionsBuy(stateDropdownOptions);

                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewStateDetails();
    }, [viewStateDetails]);

    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);

    const handleStateChange = (selectedOption) => {
        handleChange({ target: { name: "state", value: selectedOption.value } });
        handleChange({ target: { name: "city", value: "" } }); // Clear city when state changes

        // Populate city dropdown based on selected state
        setCityOptions(selectedOption.cities || []);
    };

    const handleCityChange = (selectedOption) => {
        handleChange({ target: { name: "city", value: selectedOption.value } });
    };

    useEffect(() => {
        if (formData.state) {
            const selectedState = stateOptions.find(option => option.value === formData.state);
            setCityOptions(selectedState ? selectedState.cities || [] : []);
        }
    }, [formData.state, stateOptions]);


    const [stateOptionsBuy, setStateOptionsBuy] = useState([]);
    const [cityOptionsBuy, setCityOptionsBuy] = useState([]);


    useEffect(() => {
        if (formData.buyerDetails.state) {
            const selectedState = stateOptionsBuy.find(option => option.value === formData.buyerDetails.state);
            setCityOptionsBuy(selectedState ? selectedState.cities || [] : []);
        }
    }, [formData.buyerDetails.state, stateOptionsBuy]);

    const [stateOptionsGur, setStateOptionsGur] = useState([]);
    const [cityOptionsGur, setCityOptionsGur] = useState([]);

    const [stateOptionsApl, setStateOptionsApl] = useState([]);
    const [cityOptionsApl, setCityOptionsApl] = useState([]);

    const handleStateChangeApl = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedApplicants = [...prevFormData.applicants];
            //const selectedState = stateOptionsApl.find(option => option.value === selectedOption?.value);
            //const cities = selectedState ? selectedState.cities : [];

            updatedApplicants[index] = {
                ...updatedApplicants[index],
                state: selectedOption ? selectedOption.value : '',
                city: ''

            };
            return { ...prevFormData, applicants: updatedApplicants };
        });

        // Update city options based on the selected state
        if (selectedOption) {
            const selectedState = stateOptionsApl.find(option => option.value === selectedOption.value);
            setCityOptionsApl(selectedState ? selectedState.cities : []); // Populate city options or reset to empty
        }
    };

    const handleCityChangeApl = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedApplicants = [...prevFormData.applicants];
            updatedApplicants[index] = {
                ...updatedApplicants[index],
                city: selectedOption ? selectedOption.value : '',  // Ensure correct city value is set

            };

            console.log("Updated Applicants:", updatedApplicants);  // Log the applicants after updating the city field

            return { ...prevFormData, applicants: updatedApplicants };
        });
    };


    // const handleCityChangeApl = (index, selectedOption) => {
    //     console.log("Selected Option:", selectedOption); // Log selected option
    //     setFormData((prevFormData) => {
    //         const updatedApplicants = [...prevFormData.applicants];
    //         updatedApplicants[index] = {
    //             ...updatedApplicants[index],
    //             city: selectedOption ? selectedOption.value : '',  // Update city value
    //         };
    //         console.log("Updated Applicant:", updatedApplicants[index]); // Log updated applicant
    //         const updatedFormData = { ...prevFormData, applicants: updatedApplicants };
    //         console.log("Updated Form Data:", updatedFormData); // Check the updated form data
    //         return updatedFormData;
    //     });
    // };

    // const handleCityChangeGur = (index, selectedOption) => {
    //     setFormData((prevFormData) => {
    //         const updatedGuarantors = [...prevFormData.guarantors];
    //         updatedGuarantors[index] = {
    //             ...updatedGuarantors[index],
    //             city: selectedOption ? selectedOption.value : ''
    //         };
    //         return { ...prevFormData, guarantors: updatedGuarantors };
    //     });
    // };




    //Getting Bank Details
    const viewBankDetails = useCallback(() => {
        setLoading(true);
        showBank()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success bank ", response.data);
                    const banks = response.data;
                    const bankDropdownOptions = banks.map(bank => {
                        const branchName = bank.branch && bank.branch.branchName ? bank.branch.branchName : "No Branch"; // Handle null or undefined branch
                        return {
                            value: bank.id,
                            label: `${bank.bankName} - ${branchName}`,
                        };
                    });
                    setBankOptions(bankDropdownOptions);
                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewBankDetails();
    }, [viewBankDetails]);

    const [bankOptions, setBankOptions] = useState([]);
    const handleBankChange = (selectedOption) => {
        handleChange({ target: { name: "bank.id", value: selectedOption.value } });
    };

    const viewLoanTypDetails = useCallback(() => {
        setLoading(true);
        loantypList()
            .then(response => {
                if (response.status === 200) {
                    const loantyp = response.data;
                    // Transform states and cities for dropdown
                    const loantypDropdownOptions = loantyp.map(loantyp => ({
                        value: loantyp.name,
                        label: loantyp.name,
                    }));
                    setLoanTypOptions(loantypDropdownOptions);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch data on mount
    useEffect(() => {
        viewLoanTypDetails();
    }, [viewLoanTypDetails]);

    const [loantypOptions, setLoanTypOptions] = useState([]);

    //Mortgage Properties Multi Select START
    const fetchMortgageProperties = useCallback(() => {
        if (!formData.id) return;

        setLoading(true);

        // Fetch mortgage properties for the account
        getMortgagePropertyByAccount(formData.id)
            .then(response => {
                if (response.status === 200) {
                    console.log('response.data ' + response.data);
                    const options = response.data.map(property => ({
                        value: property.id,
                        label: property.securityDetails
                    }));
                    setMultiSelectOptions(options);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    console.error("Unauthorized access, redirecting to login...");
                    authContext.logout();
                    navigate("");
                } else {
                    console.error("Error fetching mortgage property details:", error);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, [formData.id, authContext, navigate]);

    useEffect(() => {
        fetchMortgageProperties();
    }, [fetchMortgageProperties]);

    const [multiSelectOptions, setMultiSelectOptions] = useState([]);

    const handleMultiSelectChange = (index, selectedOptions) => {
        const updatedActivityDetails = [...formData.activityDetails];

        const formattedSecurityDetails = selectedOptions.map(option => ({
            id: option.value,
            securityDetails: "",
        }));

        updatedActivityDetails[index] = {
            ...updatedActivityDetails[index],
            securityDetails: formattedSecurityDetails,
        };

        setFormData({
            ...formData,
            activityDetails: updatedActivityDetails,
        });

        console.log('Updated Activity Details:', updatedActivityDetails);
    };


    //Mortgage Properties Multi Select END

    const viewactivityTypDetails = useCallback(() => {
        setLoading(true);
        activitytypList()
            .then(response => {
                if (response.status === 200) {
                    const activitytyp = response.data;
                    // Transform states and cities for dropdown
                    const activitytypDropdownOptions = activitytyp.map(activitytyp => ({
                        value: activitytyp.name,
                        label: activitytyp.name,
                    }));
                    setactivityTypOptions(activitytypDropdownOptions);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch data on mount
    useEffect(() => {
        viewactivityTypDetails();
    }, [viewactivityTypDetails]);

    const [activitytypOptions, setactivityTypOptions] = useState([]);

    const viewSecurityTypDetails = useCallback(() => {
        setLoading(true);
        securitytypList()
            .then(response => {
                if (response.status === 200) {
                    const securityTyp = response.data;
                    // Transform states and cities for dropdown
                    const securitytypDropdownOptions = securityTyp.map(securitytyp => ({
                        value: securitytyp.name,
                        label: securitytyp.name,
                    }));
                    setSecurityTypOptions(securitytypDropdownOptions);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch data on mount
    useEffect(() => {
        viewSecurityTypDetails();
    }, [viewSecurityTypDetails]);

    const [typeOfSecurityOptions, setSecurityTypOptions] = useState([]);


    const viewstatusDetails = useCallback(() => {
        setLoading(true);
        statusList()
            .then(response => {
                if (response.status === 200) {
                    const statusList = response.data;
                    // Transform states and cities for dropdown
                    const statusDropdownOptions = statusList.map(status => ({
                        value: status.name,
                        label: status.name,
                    }));
                    setStatusOptions(statusDropdownOptions);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching dashboard details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch data on mount
    useEffect(() => {
        viewstatusDetails();
    }, [viewstatusDetails]);

    const [statusOptions, setStatusOptions] = useState([]);
    // const handleStatusChange = (selectedOption) => {
    //     handleChange({ target: { name: "name", value: selectedOption.value } });
    // };


    // Handle Form Field Value Change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updatedData = { ...prev };
            const keys = name.split(".");
            let temp = updatedData;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!temp[keys[i]]) temp[keys[i]] = {};
                temp = temp[keys[i]];
            }
            temp[keys[keys.length - 1]] = value;

            return updatedData;
        });
    };

    const handleStatusTypChange = (e) => {
        if (e.target) {
            // For regular DOM elements like <textarea>
            const { name, value } = e.target;
            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        } else {
            // For react-select
            setFormData((prevState) => ({
                ...prevState,
                status: e.value, // Update based on the react-select value
            }));
        }
    };

    const validateTab1 = () => {
        const errors = {};
        let isValid = true;

        // Validate account name
        if (!formData.accountName) {
            errors.accountName = "Account Name is required.";
            isValid = false;
        }

        // Validate address fields
        if (!formData.addressLine1) {
            errors.addressLine1 = "Address Line 1 is required.";
            isValid = false;
        }
        if (!formData.addressLine2) {
            errors.addressLine2 = "Address Line 2 is required.";
            isValid = false;
        }

        // Additional validation logic can be added for other fields (bank, city, etc.)
        if (!formData.bank.id > 0) {
            errors.bankName = "Bank Name is required.";
            isValid = false;
        }

        // If there are validation errors, set the errors state
        if (!isValid) {
            setErrors(errors);
            toast.error('Please fill in all required fields in the Account section.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                style: { border: "3px solid red", padding: "10px" },
            });
        }

        return isValid;
    };

    //**********Activity Handaler START**************/

    const handleActivityDetailChange = (index, event) => {
        const { name, value } = event.target;

        setFormData(prevFormData => {
            const updatedActivityDetails = [...prevFormData.activityDetails];
            updatedActivityDetails[index] = {
                ...updatedActivityDetails[index],
                [name.split('.').pop()]: value, // Handle file inputs or regular inputs
            };
            return { ...prevFormData, activityDetails: updatedActivityDetails };
        });
    };


    const handactivityTypChange = (index, selectedOption) => {
        setFormData(prevFormData => {
            const updatedActivityDetails = [...prevFormData.activityDetails];
            updatedActivityDetails[index] = {
                ...updatedActivityDetails[index],
                activityType: selectedOption.value,
            };
            return { ...prevFormData, activityDetails: updatedActivityDetails };
        });
    };


    //**********Activity Handaler END**************/

    //**********Applicant Handaler START**************/

    const handleApplicantChange = (index, event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => {
            const updatedApplicants = [...prevFormData.applicants];
            updatedApplicants[index] = {
                ...updatedApplicants[index],
                [name.split('.').pop()]: value // Handles nested field names like "applicant.fieldName"
            };
            return { ...prevFormData, applicants: updatedApplicants };
        });
    };

    const addApplicant = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            applicants: [
                ...prevFormData.applicants,
                {
                    id: 0,
                    name: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    pinCode: '',
                    mobile: '',
                    email: ''
                }
            ]
        }));
    };

    const removeApplicant = (index) => {
        setFormData((prevFormData) => {
            const updatedApplicants = [...prevFormData.applicants];
            updatedApplicants.splice(index, 1); // Remove the applicant at the specified index
            return { ...prevFormData, applicants: updatedApplicants };
        });
    };

    //**********Applicant Handaler END**************/

    //**********Guarantor Handaler START**************/
    const addGuarantor = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            guarantors: [
                ...prevFormData.guarantors,
                {
                    id: 0,
                    name: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    pinCode: '',
                    mobile: '',
                    email: ''
                }
            ]
        }));
    };

    const removeGuarantor = (index) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            guarantors: prevFormData.guarantors.filter((_, i) => i !== index)
        }));
    };

    const handleGuarantorChange = (index, event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => {
            const updatedGuarantors = [...prevFormData.guarantors];
            updatedGuarantors[index] = {
                ...updatedGuarantors[index],
                [name.split('.').pop()]: value // Handles nested field names like "guarantor.fieldName"
            };
            return { ...prevFormData, guarantors: updatedGuarantors };
        });
    };

    const handleStateChangeGur = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedGuarantors = [...prevFormData.guarantors];
            updatedGuarantors[index] = {
                ...updatedGuarantors[index],
                state: selectedOption ? selectedOption.value : '',
                city: '' // Reset city when state changes
            };
            return { ...prevFormData, guarantors: updatedGuarantors };
        });
        if (selectedOption) {
            const selectedState = stateOptionsGur.find(option => option.value === selectedOption.value);
            setCityOptionsGur(selectedState ? selectedState.cities : []); // Set city options or empty if state is not found
        } else {
            setCityOptionsGur([]); // Clear city options if no state is selected
        }
    };

    const handleCityChangeGur = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedGuarantors = [...prevFormData.guarantors];
            updatedGuarantors[index] = {
                ...updatedGuarantors[index],
                city: selectedOption ? selectedOption.value : ''
            };
            return { ...prevFormData, guarantors: updatedGuarantors };
        });
    };

    //**********Guarantor Handaler END**************/


    //**********Security START**************/

    const handleSecurityDetailChange = (index, event) => {
        const { name, value } = event.target;

        setFormData((prevFormData) => {
            // Copy the existing securityDetails array
            const updatedSecurityDetails = [...prevFormData.securityDetails];

            // Update the specific security detail at the given index
            updatedSecurityDetails[index] = {
                ...updatedSecurityDetails[index],
                [name.split('.').pop()]: value // Handles nested field names if needed
            };

            // Return the updated state
            return { ...prevFormData, securityDetails: updatedSecurityDetails };
        });
    };


    const handleSecurityTypChange = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedSecurityDetails = [...prevFormData.securityDetails];
            updatedSecurityDetails[index] = {
                ...updatedSecurityDetails[index],
                securityType: selectedOption ? selectedOption.value : '',
            };
            return { ...prevFormData, securityDetails: updatedSecurityDetails };
        });
    };

    const addSecurityDetail = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            securityDetails: [
                ...prevFormData.securityDetails,
                {
                    id: 0,
                    securityType: "",
                    securityDetails: "",
                    towardsEast: "",
                    towardsWest: "",
                    towardsNorth: "",
                    towardsSouth: ""
                },
            ],
        }));
    };

    const removeSecurityDetail = (index) => {
        setFormData((prevFormData) => {
            const updatedSecurityDetails = [...prevFormData.securityDetails];
            updatedSecurityDetails.splice(index, 1);
            return { ...prevFormData, securityDetails: updatedSecurityDetails };
        });
    };

    //**********Security END**************/

    //**********Buyear Details START**************/
    const handleBuyerTypeChange = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedBuyerDetails = [...prevFormData.buyerDetails];
            updatedBuyerDetails[index] = {
                ...updatedBuyerDetails[index],
                buyertype: selectedOption ? selectedOption.value : null,
            };
            return {
                ...prevFormData,
                buyerDetails: updatedBuyerDetails,
            };
        });
    };



    const addBuyerDetail = () => {
        setFormData((prevState) => ({
            ...prevState,
            buyerDetails: [
                ...prevState.buyerDetails,
                {
                    buyertype: '',
                    name: '',
                    addressLine1: '',
                    addressLine2: '',
                    state: '',
                    city: '',
                    pinCode: '',
                    mobile: '',
                    email: '',
                    pan: '',
                    aadhar: ''
                }
            ]
        }));
    };

    const removeBuyerDetail = (index) => {
        setFormData((prevState) => ({
            ...prevState,
            buyerDetails: prevState.buyerDetails.filter((_, i) => i !== index)
        }));
    };

    const handleBuyerChange = (index, event) => {
        const { name, value } = event.target;
        setFormData((prevState) => {
            const buyerDetails = [...prevState.buyerDetails];
            buyerDetails[index] = {
                ...buyerDetails[index],
                [name.split('.').pop()]: value,
            };
            return { ...prevState, buyerDetails };
        });
    };

    const handleStateChangeBuy = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedBuyers = [...prevFormData.buyerDetails];

            // Find the selected state and corresponding cities
            // const selectedState = stateOptionsBuy.find(option => option.value === selectedOption?.value);
           // const cities = selectedState ? selectedState.cities : [];

            // Update the specific buyer's state and reset city
            updatedBuyers[index] = {
                ...updatedBuyers[index],
                state: selectedOption ? selectedOption.value : '',
                city: '', // Reset city when state changes
            };

            return {
                ...prevFormData,
                buyerDetails: updatedBuyers, // Correct key to update buyerDetails
            };
        });

        // Update city options based on the selected state
        if (selectedOption) {
            const selectedState = stateOptionsBuy.find(option => option.value === selectedOption.value);
            setCityOptionsBuy(selectedState ? selectedState.cities : []); // Populate or reset city options
        }
    };

    const handleCityChangeBuy = (index, selectedOption) => {
        setFormData((prevFormData) => {
            const updatedBuyers = [...prevFormData.buyerDetails];

            // Update the specific buyer's city
            updatedBuyers[index] = {
                ...updatedBuyers[index],
                city: selectedOption ? selectedOption.value : '', // Set the city value
            };

            console.log("Updated Buyers:", updatedBuyers); // Log updated buyers for debugging

            return {
                ...prevFormData,
                buyerDetails: updatedBuyers, // Correct key for buyerDetails
            };
        });
    };


    //**********Buyear Details END**************/

    const handleFileChange = (index, e) => {
        const { files } = e.target; // Extract files from the event
        const fileArray = Array.from(files); // Convert FileList to Array

        const activityDetails = [...formData.activityDetails];
        const existingFileNames = activityDetails[index].fileEvidencePath || '';

        // Generate the pre-generated key names based on the file names
        const preGeneratedKeyNames = fileArray.map((file) => `${Date.now()}_${file.name}`);

        // Prepare FormData for file upload
        const fileFormData = new FormData();

        // Loop through each file and append the pre-generated keyName
        fileArray.forEach((file, i) => {
            const keyName = preGeneratedKeyNames[i]; // Use the pre-generated key name from the array
            fileFormData.append("file", file);
            fileFormData.append("keyName", keyName);
        });

        setLoading(true); // Set loading state

        uploadFile(fileFormData)
            .then((response) => {
                if (response.status === 202 || response.status === 200) {
                    const updatedKeyNames = preGeneratedKeyNames.join(', '); // Join the key names for the update

                    // Update fileEvidencePath with comma-separated keyNames
                    activityDetails[index].fileEvidencePath = existingFileNames
                        ? `${existingFileNames}, ${updatedKeyNames}`
                        : updatedKeyNames;

                    // Update formData state
                    setFormData({ ...formData, activityDetails });
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error during file upload:', error);
                alert('File upload failed! Please try again.');
            });
    };


    const downloadFile = async (fileName) => {
        try {
            // Log the file name for debugging
            console.log("Downloading file:", fileName);

            // Call the function to fetch the image or file from the server
            const response = await showImage(fileName);

            // Check if the response is successful
            if (response.status === 200 || response.status === 202) {
                // Create a Blob from the byte array (response.data) and specify the MIME type
                const byteArray = new Uint8Array(response.data);  // Convert the response.data to a byte array (if not already)
                const blob = new Blob([byteArray], {
                    type: response.headers["content-type"], // Use the content type from the response headers
                });

                // Create a temporary link to download the file
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob); // Create a URL for the Blob
                link.download = fileName; // Set the download attribute to specify the file name

                // Append the link to the body (it must be part of the document for the click to work)
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link after the download starts
                document.body.removeChild(link);
            } else {
                console.error("Failed to fetch the file, status:", response.status);
            }
        } catch (error) {
            console.error("Error fetching the file:", error);
        }
    };


    // Remove file from fileEvidencePath
    const removeFile = (index, fileName) => {
        const activityDetails = [...formData.activityDetails];
        const updatedFileNames = activityDetails[index].fileEvidencePath
            .split(', ')
            .filter((file) => file !== fileName)
            .join(', ');

        activityDetails[index].fileEvidencePath = updatedFileNames;

        // Update formData state
        setFormData({ ...formData, activityDetails });
    };


    return (
        <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            {loading && <Loading />}
            <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            <div id="layoutSidenav">
                <SideNave isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav_content">
                    <main>
                        <div className="container-fluid px-4">
                            <h6 className="mt-4">Case Details</h6>
                            <div className="card mb-4 border-0">
                                <div className="card-body">
                                    <ul className="nav nav-tabs nav-fill">
                                        <li className="nav-item">
                                            <button className={`nav-item nav-link ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleTabChange(1)}>Account</button>
                                        </li>
                                        <li className="nav-item">
                                            <button className={`nav-item nav-link ${activeTab === 2 ? 'active' : ''}`} onClick={() => handleTabChange(2)}>Applicant & Guarantor</button>
                                        </li>
                                        <li className="nav-item">
                                            <button className={`nav-item nav-link ${activeTab === 3 ? 'active' : ''}`} onClick={() => handleTabChange(3)}>Security</button>
                                        </li>
                                        <li className="nav-item">
                                            <button className={`nav-item nav-link ${activeTab === 4 ? 'active' : ''}`} onClick={() => handleTabChange(4)}>Buyer</button>
                                        </li>
                                        <li className="nav-item">
                                            <button className={`nav-item nav-link ${activeTab === 5 ? 'active' : ''}`} onClick={() => handleTabChange(5)}>Activity & Status</button>
                                        </li>
                                    </ul>
                                    <form className="mt-3">
                                        {/* Tab 1 Content */}
                                        {activeTab === 1 && (
                                            <>
                                                <div className="container">
                                                    <div className="row mb-1">
                                                        <div className="col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Bank</label>
                                                            <Select
                                                                name="bank.id"
                                                                value={bankOptions.find(option => option.value === formData.bank.id) || null}
                                                                onChange={handleBankChange}
                                                                options={bankOptions}
                                                                className="form-control form-control-sm p-0"
                                                                placeholder="Select Bank"
                                                                isSearchable />
                                                            {renderError("bankName")}
                                                        </div>
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Account Name</label>
                                                            <input
                                                                type="text"
                                                                name="accountName"
                                                                value={formData.accountName}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Account Name"
                                                            />
                                                            {renderError("accountName")}
                                                        </div>
                                                    </div>
                                                    <div className="row mb-1">
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                            <input
                                                                type='text'
                                                                name="addressLine1"
                                                                value={formData.addressLine1}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Address Line 1"
                                                            />
                                                            {renderError("addressLine1")}
                                                        </div>
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                            <input
                                                                type='text'
                                                                name="addressLine2"
                                                                value={formData.addressLine2}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Address Line 2"
                                                            />
                                                            {renderError("addressLine2")}
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                            <Select
                                                                name="state"
                                                                value={stateOptions.find(option => option.value === formData.state) || null}
                                                                onChange={handleStateChange}
                                                                options={stateOptions}
                                                                className="form-control form-control-sm p-0"
                                                                placeholder="Select State"
                                                                isSearchable
                                                            />
                                                            {errors.state && <span className="text-danger">{errors.state}</span>}
                                                        </div>
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                            <Select
                                                                name="city"
                                                                value={cityOptions.find(option => option.value === formData.city) || null}
                                                                onChange={handleCityChange}
                                                                options={cityOptions}
                                                                className="form-control form-control-sm p-0"
                                                                placeholder="Select City"
                                                                isSearchable
                                                                isDisabled={!formData.state} />
                                                            {errors.city && <span className="text-danger">{errors.city}</span>}
                                                        </div>
                                                    </div>

                                                    <div className="row mb-1">
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                            <input
                                                                type="number"
                                                                name="pinCode"
                                                                value={formData.pinCode}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Pincode"
                                                            />
                                                            {errors.pincode && <span className="text-danger">{errors.pincode}</span>}
                                                        </div>
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                            <input
                                                                type="text"
                                                                name="phoneNumber"
                                                                value={formData.phoneNumber}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Phone Number"
                                                            />
                                                            {errors.phoneNumber && <span className="text-danger">{errors.phoneNumber}</span>}
                                                        </div>
                                                        <div className="col-sm-12 col-md-6">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Email"
                                                            />
                                                            {errors.email && <span className="text-danger">{errors.email}</span>}
                                                        </div>
                                                    </div>< br />
                                                    {formData.loanType.map((loanType, index) => (
                                                        <div key={index} className="card mb-3 shadow-none">
                                                            <div className="card-header bg-info">
                                                                Loan Detail {index + 1}
                                                                {formData.loanType.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm float-end ms-2"
                                                                        onClick={() => removeLoanDetail(index)}
                                                                    >
                                                                        <FaRegTrashAlt />
                                                                    </button>
                                                                )}
                                                                {index === formData.loanType.length - 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm float-end"
                                                                        onClick={addLoanDetail}
                                                                    >
                                                                        <FaPlus />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            <div className="card-body">
                                                                <input
                                                                    type="hidden"
                                                                    name="loanType.id"
                                                                    value={loanType.id || 0}
                                                                    onChange={(e) => handleLoanDetailChange(index, e)}
                                                                    readOnly
                                                                />
                                                                <div className="row mb-1">
                                                                    <div className="col-md-6">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Type of Loan</label>
                                                                        <Select
                                                                            name="loanType.loanType"
                                                                            value={loantypOptions.find(option => option.value === loanType.loanType) || null}
                                                                            onChange={(selectedOption) => handleLoanTypChange(index, selectedOption)} // Pass the index here
                                                                            options={loantypOptions}
                                                                            className="form-control form-control-sm p-0"
                                                                            placeholder="Select Loan Type"
                                                                            isSearchable
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Sanction Date</label>
                                                                        <input
                                                                            type="date"
                                                                            name="loanType.sanctionDate"
                                                                            value={loanType.sanctionDate}
                                                                            onChange={(e) => handleLoanDetailChange(index, e)}
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-1">
                                                                    <div className="col-md-3">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Sanction Amount</label>
                                                                        <input
                                                                            type="number"
                                                                            name="loanType.sanctionAmount"
                                                                            value={loanType.sanctionAmount}
                                                                            onChange={(e) => handleLoanDetailChange(index, e)}
                                                                            className="form-control form-control-sm"
                                                                            placeholder="Enter Sanction Amount"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Outstanding As Of</label>
                                                                        <input
                                                                            type="date"
                                                                            name="loanType.outstandingAsOf"
                                                                            value={loanType.outstandingAsOf}
                                                                            onChange={(e) => handleLoanDetailChange(index, e)}
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Outstanding Amount</label>
                                                                        <input
                                                                            type="number"
                                                                            name="loanType.outstandingAmount"
                                                                            value={loanType.outstandingAmount}
                                                                            onChange={(e) => handleLoanDetailChange(index, e)}
                                                                            className="form-control form-control-sm"
                                                                            placeholder="Enter Outstanding Amount"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label form-control-sm mb-0 ps-0">Rate of Interest</label>
                                                                        <input
                                                                            type="number"
                                                                            name="loanType.rateOfInterest"
                                                                            value={loanType.rateOfInterest}
                                                                            onChange={(e) => handleLoanDetailChange(index, e)}
                                                                            className="form-control form-control-sm"
                                                                            placeholder="Enter Outstanding Amount"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="row mb-3">
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Date of Allotment</label>
                                                            <input
                                                                type="date"
                                                                name="dateOfAllotment"
                                                                value={formData.dateOfAllotment}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">NPA Date</label>
                                                            <input
                                                                type="date"
                                                                name="npaDate"
                                                                value={formData.npaDate}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Date of 13(2)</label>
                                                            <input
                                                                type="date"
                                                                name="dateOf132"
                                                                value={formData.dateOf132}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Amount Demanded As Per 13(2)</label>
                                                            <input
                                                                type="number"
                                                                name="amountDemanded132"
                                                                value={formData.amountDemanded132}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Amount Demanded"
                                                            />
                                                        </div>
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Date of 13(4)</label>
                                                            <input
                                                                type="date"
                                                                name="dateOf134"
                                                                value={formData.dateOf134}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                        <div className="col-md-4 col-sm-12">
                                                            <label className="form-label form-control-sm mb-0 ps-0">Registered Mortgage Before Sub-Registrar</label>
                                                            <input
                                                                type="text"
                                                                name="registeredMortgagedSrNo"
                                                                value={formData.registeredMortgagedSrNo}
                                                                onChange={handleChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Registered Mortgage"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* Tab 2 Content */}
                                        {activeTab === 2 && (
                                            <>
                                                {formData.applicants.map((applicant, index) => (
                                                    <div key={index} className="card mb-3 shadow-none">
                                                        <div className="card-header bg-info">
                                                            Applicant {index + 1}
                                                            {formData.applicants.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm float-end ms-2"
                                                                    onClick={() => removeApplicant(index)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            )}
                                                            {index === formData.applicants.length - 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm float-end"
                                                                    onClick={addApplicant}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <div className="card-body">
                                                            <input
                                                                type="hidden"
                                                                name="applicant.id"
                                                                value={applicant.id || ''}
                                                                onChange={(e) => handleApplicantChange(index, e)}
                                                                readOnly
                                                            />
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Applicant Name</label>
                                                                    <input
                                                                        type="text"
                                                                        name="applicant.name"
                                                                        value={applicant.name}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Applicant Name"
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                                    <input
                                                                        type="text"
                                                                        name="applicant.mobile"
                                                                        value={applicant.mobile}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Phone Number"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                                    <input
                                                                        ype='text'
                                                                        name="applicant.addressLine1"
                                                                        value={applicant.addressLine1}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 1"
                                                                    ></input>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                                    <input
                                                                        type='text'
                                                                        name="applicant.addressLine2"
                                                                        value={applicant.addressLine2}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 2"
                                                                    ></input>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                                    <Select
                                                                        name="applicant.state"
                                                                        value={stateOptionsApl.find(option => option.value === applicant.state) || null}
                                                                        onChange={(selectedOption) => handleStateChangeApl(index, selectedOption)}
                                                                        options={stateOptionsApl}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select State"
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                                    <Select
                                                                        name="applicant.city"
                                                                        //value={cityOptionsApl.find(option => option.value === applicant.city) || null}  // Ensure value is an object
                                                                        value={applicant.city ? { value: applicant.city, label: applicant.city } : null}
                                                                        onChange={(selectedOption) => handleCityChangeApl(index, selectedOption)}
                                                                        options={cityOptionsApl}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select City"
                                                                        isSearchable
                                                                        isDisabled={!applicant.state}
                                                                    />

                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                                    <input
                                                                        type="number"
                                                                        name="applicant.pinCode"
                                                                        value={applicant.pinCode}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Pincode"
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                                    <input
                                                                        type="email"
                                                                        name="applicant.email"
                                                                        value={applicant.email}
                                                                        onChange={(e) => handleApplicantChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Email"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                                {formData.guarantors.map((guarantor, index) => (
                                                    <div key={index} className="card mb-3 shadow-none">
                                                        <div className="card-header bg-info">
                                                            Guarantor {index + 1}
                                                            {formData.guarantors.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm float-end ms-2"
                                                                    onClick={() => removeGuarantor(index)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            )}
                                                            {index === formData.guarantors.length - 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm float-end"
                                                                    onClick={addGuarantor}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <div className="card-body">
                                                            <input
                                                                type="hidden"
                                                                name="guarantor.id"
                                                                value={guarantor.id || ''}
                                                                onChange={(e) => handleGuarantorChange(index, e)}
                                                                readOnly
                                                            />
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Guarantor Name</label>
                                                                    <input
                                                                        type="text"
                                                                        name="guarantor.name"
                                                                        value={guarantor.name}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Guarantor Name"
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Phone Number</label>
                                                                    <input
                                                                        type="text"
                                                                        name="guarantor.mobile"
                                                                        value={guarantor.mobile}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Phone Number"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                                    <input
                                                                        type='text'
                                                                        name="guarantor.addressLine1"
                                                                        value={guarantor.addressLine1}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 1"
                                                                    ></input>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                                    <input
                                                                        type='text'
                                                                        name="guarantor.addressLine2"
                                                                        value={guarantor.addressLine2}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 2"
                                                                    ></input>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                                    <Select
                                                                        name="guarantor.state"
                                                                        value={stateOptionsGur.find(option => option.value === guarantor.state) || null}
                                                                        onChange={(selectedOption) => handleStateChangeGur(index, selectedOption)}
                                                                        options={stateOptionsGur}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select State"
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                                    <Select
                                                                        name="guarantor.city"
                                                                        //value={cityOptionsGur.find(option => option.value === guarantor.city) || null}
                                                                        value={guarantor.city ? { value: guarantor.city, label: guarantor.city } : null}
                                                                        onChange={(selectedOption) => handleCityChangeGur(index, selectedOption)}
                                                                        options={cityOptionsGur}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select City"
                                                                        isSearchable
                                                                        isDisabled={!guarantor.state} />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                                    <input
                                                                        type="number"
                                                                        name="guarantor.pinCode"
                                                                        value={guarantor.pinCode}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Pincode"
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                                    <input
                                                                        type="email"
                                                                        name="guarantor.email"
                                                                        value={guarantor.email}
                                                                        onChange={(e) => handleGuarantorChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Email"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                        {/* Tab 3 Content */}
                                        {activeTab === 3 && (
                                            <>
                                                {formData.securityDetails.map((security, index) => (
                                                    <div key={index} className="card mb-3 shadow-none">
                                                        <div className="card-header bg-info">
                                                            Security Detail {index + 1}

                                                            {formData.securityDetails.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm float-end ms-2"
                                                                    onClick={() => removeSecurityDetail(index)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            )}
                                                            {index === formData.securityDetails.length - 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm float-end"
                                                                    onClick={addSecurityDetail}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row mb-1">
                                                                <div className="col-md-5">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Type of Security</label>
                                                                    <Select
                                                                        name="security.securityType"
                                                                        value={typeOfSecurityOptions.find(option => option.value === security.securityType) || null}
                                                                        onChange={(selectedOption) => handleSecurityTypChange(index, selectedOption)} // Pass the index here
                                                                        options={typeOfSecurityOptions}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select Security Type"
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Security Details</label>
                                                                    <textarea
                                                                        name="security.securityDetails"
                                                                        value={security.securityDetails}
                                                                        onChange={(e) => handleSecurityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Security Details"
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">On or towards the East</label>
                                                                    <input
                                                                        type="text"
                                                                        name="security.towardsEast"
                                                                        value={security.towardsEast}
                                                                        onChange={(e) => handleSecurityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter East Details"
                                                                    />
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">On or towards the West</label>
                                                                    <input
                                                                        type="text"
                                                                        name="security.towardsWest"
                                                                        value={security.towardsWest}
                                                                        onChange={(e) => handleSecurityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter West Details"
                                                                    />
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">On or towards the North</label>
                                                                    <input
                                                                        type="text"
                                                                        name="security.towardsNorth"
                                                                        value={security.towardsNorth}
                                                                        onChange={(e) => handleSecurityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter North Details"
                                                                    />
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">On or towards the South</label>
                                                                    <input
                                                                        type="text"
                                                                        name="security.towardsSouth"
                                                                        value={security.towardsSouth}
                                                                        onChange={(e) => handleSecurityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter South Details"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                        {/* Tab 4 Content */}
                                        {activeTab === 4 && (
                                            <>
                                                {formData.buyerDetails.map((buyer, index) => (
                                                    <div key={index} className="card mb-3 shadow-none">
                                                        <div className="card-header bg-info">
                                                            Buyer Detail {index + 1}

                                                            {formData.buyerDetails.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm float-end ms-2"
                                                                    onClick={() => removeBuyerDetail(index)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            )}
                                                            {index === formData.buyerDetails.length - 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm float-end"
                                                                    onClick={addBuyerDetail}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row mb-1">
                                                                <div className="col-md-4">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Buyer Type</label>
                                                                    <Select
                                                                        name="buyer.buyertype"
                                                                        value={
                                                                            buyer.buyertype
                                                                                ? { value: buyer.buyertype, label: buyer.buyertype }
                                                                                : null
                                                                        }
                                                                        onChange={(selectedOption) => handleBuyerTypeChange(index, selectedOption)}
                                                                        options={[
                                                                            { value: "Potential Buyer", label: "Potential Buyer" },
                                                                            { value: "Actual Buyer", label: "Actual Buyer" },
                                                                        ]}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select Buyer Type"
                                                                        isSearchable
                                                                    />

                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Buyer Name</label>
                                                                    <input
                                                                        type="text"
                                                                        name="buyer.name"
                                                                        value={buyer.name}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Buyer Name"
                                                                    />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 1</label>
                                                                    <input
                                                                        type="text"
                                                                        name="buyer.addressLine1"
                                                                        value={buyer.addressLine1}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 1"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">State</label>
                                                                    <Select
                                                                        name="buyer.state"
                                                                        value={stateOptionsBuy.find(option => option.value === buyer.state) || null}
                                                                        onChange={(selectedOption) => handleStateChangeBuy(index, selectedOption)}
                                                                        options={stateOptionsBuy}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select State"
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Address Line 2</label>
                                                                    <input
                                                                        type="text"
                                                                        name="buyer.addressLine2"
                                                                        value={buyer.addressLine2}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Address Line 2"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">City</label>
                                                                    <Select
                                                                        name="buyer.city"
                                                                        value={buyer.city ? { value: buyer.city, label: buyer.city } : null}
                                                                        onChange={(selectedOption) => handleCityChangeBuy(index, selectedOption)}
                                                                        options={cityOptionsBuy}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select City"
                                                                        isSearchable
                                                                        isDisabled={!buyer.state}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Pincode</label>
                                                                    <input
                                                                        type="number"
                                                                        name="buyer.pinCode"
                                                                        value={buyer.pinCode}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Pincode"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-sm-12 col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Mobile Number</label>
                                                                    <input
                                                                        type="text"
                                                                        name="buyer.mobile"
                                                                        value={buyer.mobile}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Phone Number"
                                                                    />
                                                                </div>
                                                                <div className="col-sm-12 col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Email</label>
                                                                    <input
                                                                        type="email"
                                                                        name="buyer.email"
                                                                        value={buyer.email}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Email"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div className="col-sm-12 col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">PAN</label>
                                                                    <input
                                                                        type="text"
                                                                        name="buyer.pan"
                                                                        value={buyer.pan}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter PAN Number"
                                                                    />
                                                                </div>
                                                                <div className="col-sm-12 col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Aadhar#</label>
                                                                    <input
                                                                        type="number"
                                                                        name="buyer.aadhar"
                                                                        value={buyer.aadhar}
                                                                        onChange={(e) => handleBuyerChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Aadhar#"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                        {/* Tab 5 Content */}
                                        {activeTab === 5 && (
                                            <>
                                                {formData.activityDetails.map((activity, index) => (
                                                    <div key={index} className="card mb-3 shadow-none">
                                                        <div className="card-header bg-info">
                                                            Activity Detail {index + 1}
                                                            {formData.activityDetails.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm float-end ms-2"
                                                                    onClick={() => removeActivityDetail(index)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button>
                                                            )}
                                                            {index === formData.activityDetails.length - 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm float-end"
                                                                    onClick={addActivityDetail}
                                                                >
                                                                    <FaPlus />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <div className="card-body">
                                                            <input
                                                                type="hidden"
                                                                name="activity.id"
                                                                value={activity.id || 0}
                                                                onChange={(e) => handleLoanDetailChange(index, e)}
                                                                readOnly
                                                            />
                                                            <div className="row mb-1">
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Activity Type</label>
                                                                    <Select
                                                                        name="activity.activityType"
                                                                        value={activitytypOptions.find(option => option.value === activity.activityType) || null}
                                                                        onChange={(selectedOption) => handactivityTypChange(index, selectedOption)} // Pass the index here
                                                                        options={activitytypOptions}
                                                                        className="form-control form-control-sm p-0"
                                                                        placeholder="Select Activity Type"
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Date of Activity</label>
                                                                    <input
                                                                        type="date"
                                                                        name="activity.dateOfActivity"
                                                                        value={activity.dateOfActivity}
                                                                        onChange={(e) => handleActivityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">

                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Time Spent (hours)</label>
                                                                    <input
                                                                        type="number"
                                                                        name="activity.timeSpent"
                                                                        value={activity.timeSpent}
                                                                        onChange={(e) => handleActivityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Time Spent"
                                                                    />
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Approx Expense</label>
                                                                    <input
                                                                        type="number"
                                                                        name="activity.approxExpenses"
                                                                        value={activity.approxExpenses}
                                                                        onChange={(e) => handleActivityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Approximate Expense"
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label className="form-label form-control-sm mb-0 ps-0">Activity Details</label>
                                                                    <textarea
                                                                        name="activity.activityDetails"
                                                                        value={activity.activityDetails}
                                                                        onChange={(e) => handleActivityDetailChange(index, e)}
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Enter Activity Details"
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Conditional Fields */}
                                                            {(activity.activityType === 'DM/CMM/CJM Permission Received' || activity.activityType === 'Police Protection Letter') && (
                                                                <>
                                                                    <div className="row mb-1">
                                                                        <div className="col-md-6">
                                                                            <label className="form-label form-control-sm mb-0 ps-0">Office Location</label>
                                                                            <input
                                                                                type="text"
                                                                                name="activity.officelocation"
                                                                                value={activity.officelocation || ''}
                                                                                onChange={(e) => handleActivityDetailChange(index, e)}
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Office Location"
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label className="form-label form-control-sm mb-0 ps-0">Select mortgage property</label>
                                                                            {/* <Select
                                                                                name="activity.securityDetails.id"
                                                                                value={(activity.securityDetails.id || []).map(value =>
                                                                                    multiSelectOptions.find(option => option.value === value)
                                                                                )}
                                                                                onChange={(selectedOptions) => handleMultiSelectChange(index, selectedOptions)}
                                                                                options={multiSelectOptions}
                                                                                className="form-control form-control-sm p-0"
                                                                                placeholder="Select Mortgage Property"
                                                                                isMulti
                                                                                isSearchable
                                                                            /> */}
                                                                            <Select
                                                                                name={`activity.securityDetails.id`}
                                                                                value={activity.securityDetails.map(sd =>
                                                                                    multiSelectOptions.find(option => option.value === sd.id)
                                                                                )}
                                                                                onChange={(selectedOptions) => handleMultiSelectChange(index, selectedOptions)}
                                                                                options={multiSelectOptions}
                                                                                className="form-control form-control-sm p-0"
                                                                                placeholder="Select Mortgage Property"
                                                                                isMulti
                                                                                isSearchable
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            <div className="mb-3">
                                                                <label className="form-label form-control-sm mb-0 ps-0">Evidence</label>
                                                                <div>
                                                                    <label htmlFor={`fileEvidence-${index}`} className="btn btn-secondary btn-sm">
                                                                        Choose Files
                                                                    </label>
                                                                    <span className="ms-2">
                                                                        {formData.activityDetails[index].fileEvidencePath
                                                                            ? `${formData.activityDetails[index].fileEvidencePath.split(', ').length} file(s) selected`
                                                                            : 'No files selected'}
                                                                    </span>
                                                                    <input
                                                                        type="file"
                                                                        name="fileEvidence"
                                                                        onChange={(e) => handleFileChange(index, e)}
                                                                        className="d-none"
                                                                        id={`fileEvidence-${index}`}
                                                                        multiple
                                                                    />
                                                                </div>

                                                                {formData.activityDetails[index].fileEvidencePath && (
                                                                    <div className="mt-3">
                                                                        {formData.activityDetails[index].fileEvidencePath.split(', ').map((keyName, idx) => (
                                                                            <div key={idx} className="d-flex justify-content-between align-items-center mb-1 p-2 border rounded">
                                                                                <div className="d-flex justify-content-start align-items-center">
                                                                                    <span className="me-3 fs-6 text-truncate" style={{ maxWidth: '300px' }}>
                                                                                        {keyName}
                                                                                    </span>
                                                                                    {/* Space for file name */}
                                                                                </div>

                                                                                <div className="d-flex justify-content-end align-items-center">
                                                                                    {/* Delete Button */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger btn-sm me-1"
                                                                                        onClick={() => removeFile(index, keyName)}
                                                                                    >
                                                                                        <TiDeleteOutline />
                                                                                    </button>

                                                                                    {/* Download Button */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-sm m-0"
                                                                                        onClick={() => downloadFile(keyName)} // Download the file when clicked
                                                                                    >
                                                                                        <IoMdDownload />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                            </div>

                                                        </div>
                                                    </div>

                                                ))}

                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Status</label>
                                                        <Select
                                                            name="status"
                                                            value={statusOptions.find(option => option.value === formData.status) || null}
                                                            onChange={handleStatusTypChange}
                                                            options={statusOptions}
                                                            className="form-control form-control-sm p-0"
                                                            placeholder="Select State"
                                                            isSearchable
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label form-control-sm mb-0 ps-0">Remarks</label>
                                                        <textarea
                                                            name="remark"
                                                            value={formData.remark}
                                                            onChange={handleChange}
                                                            className="form-control form-control-sm"
                                                            placeholder="Enter Remarks"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <hr />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-warning"
                                            onClick={() => handleSave(activeTab + 1)}
                                        >
                                            <>
                                                Save <FaRegSave />
                                            </>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}    
